import { render, staticRenderFns } from "./FormOption.vue?vue&type=template&id=b2fe976e&"
import script from "./FormOption.vue?vue&type=script&lang=js&"
export * from "./FormOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports